export default __webpack_public_path__ + "static/media/logo.6597dc7d.svg";